
import * as React from 'react';
import { DashboardContainerProps } from 'piral';
import instance from './index';
import {Button, Box, Paper, Stack, ThemeProvider, Typography} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Dashboard: React.FC<DashboardContainerProps> = ({ children }) => {
  const theme = instance.root.getData('Theme');



  const DashboardDisplay = () => {
    const backgroundImage = instance.root.getData('backgroundImage');

    return <>
        <Box
          sx={{
            width: '100%',
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            padding: 0
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexGrow: '1',
              flexDirection: 'row',
              justifyContent: 'start',
              paddingX: '40px',
              paddingY: '24px',
              backgroundImage: `url(${backgroundImage})`,
              backgroundPosition: 'left bottom',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              overflow: 'hidden'
            }}
          >

              <Stack
                direction="column"
                // justifyContent="space-around"
                alignItems="left"
                spacing={1} 
                sx={{
                  width: '80%',
                  maxWidth: '900px',}}
              >
                <Typography variant="h4" fontWeight={"800"} sx={{ color: useTheme().palette.primary.contrastText }}>
                  Public Improvement District Administration
                </Typography>
                <Typography variant="h4" paddingBottom={'36px'}>
                  Public Improvement District Administration 
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ maxWidth: '600px', color: useTheme().palette.primary.contrastText }}>
                  body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
                  blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur,
                  neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum
                  quasi quidem quibusdam.
                </Typography>
              </Stack>
          </Box>
          <Box
            sx={{backgroundColor: useTheme().palette.background.default,
                color: useTheme().palette.primary.contrastText,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'start',
                paddingX: '40px',
                paddingY: '24px',}}>
                  <Stack>
               <Typography variant="h4" paddingBottom={'36px'}>
                  About Us 
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ maxWidth: '600px' }}>
                  About info for WFS and the Public Improvement District Administration program. 
                </Typography>
                </Stack>
            </Box>
        </Box>
      <Box sx={{flexGrow:'1'}} />
    </>
  }

  return(
    <div style={{ flex: '1 1 auto', overflowY: 'auto' }}>
      <ThemeProvider theme={theme}>
        < DashboardDisplay />
      </ThemeProvider>      
    </div>
  )};

  export default Dashboard;